// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3V9UY","overflowing":"ReadFullNote_overflowing__22heM"};